/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Copy_Text_LabelInputs */



/**
* | output |
* | --- |
* | "Copy text from selected events" |
*
* @param {Context_Menu_Copy_Text_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_copy_text_label = /** @type {((inputs?: Context_Menu_Copy_Text_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Copy_Text_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier le texte des événements sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text aus ausgewählten Ereignissen kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia il testo dagli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать текст из выбранных событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar texto de eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从选定的事件中复制文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントからテキストをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं से पाठ कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar texto dos eventos selecionados")
	return /** @type {LocalizedString} */ ("Copy text from selected events")
});